const accessAsset = {

    ADD_GRN: { name: 'Add GRN', path: '/add-grn' },
    UPDATE_GRN: { name: 'Edit GRN', path: '/edit-grn' },
    GRN_LIST: { name: 'GRN', path: '/grn-list' },
    ASSET_LIST: { name: 'Asset', path: '/asset-list' },
    GRN_DETAILS: { name: 'GRN Detail', path: '/grn-detail' },
    
    ADD_STOCK: { name: 'Add Stock', path: '/add-stock' },
    STOCK_LIST: { name: 'Stock', path: '/stock-list' },
    PENDING_ASSET_CONVERSION_LIST: { name: 'Pending Asset Conversion', path: '/pending-asset-conversion-list' },
    QR_CODE_STOCK: { name: 'QR Code Stock', path: '/qr-code-stock' },

    ADD_ASSET_ISSUE: { name: 'Add Asset Issue', path: '/add-asset-issue' },
    ASSET_ISSUE_DETAILS: { name: 'Asset Issue Detail', path: '/asset-issue-detail' },
    ASSET_ISSUE_LIST: { name: 'Asset Issue', path: '/asset-issue-list' },
    QR_CODE_ISSUE: { name: 'QR Code Issue', path: '/qr-code-issue' },

    ADD_TOOLS_PARTS_TRANSFER: { name: 'Add Tools Parts Transfer', path: '/add-tools-parts-transfer' },
    UPDATE_TOOLS_PARTS_TRANSFER: { name: 'Edit Tools Parts Transfer', path: '/edit-tools-parts-transfer' },
    TOOLS_PARTS_TRANSFER_DETAILS: { name: 'Tools Parts Transfer Detail', path: '/tools-parts-transfer-detail' },
    TOOLS_PARTS_TRANSFER_LIST: { name: 'Tools Parts Transfer', path: '/tools-parts-transfer-list' },
    DELETE_TOOLS_PARTS_TRANSFER: { name: 'Delete Tools Parts Transfer', path: '/delete-tools-parts-transfer' },

    ADD_TOOLS_PARTS_RETURN: { name: 'Add Tools Parts Return', path: '/add-tools-parts-return' },
    TOOLS_PARTS_RETURN_LIST: { name: 'Tools Parts Return', path: '/tools-parts-return-list' },

    AMC_LIST: { name: 'AMC', path: '/amc-list' },
    ADD_AMC: { name: 'Add AMC', path: '/add-amc' },
    UPDATE_AMC: { name: 'Edit AMC', path: '/edit-amc' },
    AMC_DETAILS: { name: 'AMC Detail', path: '/amc-detail' },
    DELETE_AMC: { name: 'Delete AMC', path: '/delete-amc' },


    ASSET_DETAILS: { name: 'Asset Detail', path: '/asset-detail' },
    ADD_WARRANTY: { name: 'Add Warranty', path: '/add-warranty' },

    ADD_INVENTORY: { name: 'Add Barcode', path: '/add-barcode' },

    ASSET_LOCATION: { name: 'Asset Location', path: '/asset-location' },
    ASSET_LOCATION_DETAILS: { name: 'Asset Location Details', path: '/asset-location-details' },



}

export default accessAsset;